import permissions from 'api/Apollo/permissions';
import { METHOD, PATH } from 'api/control/control-api';
import { useControlProxy, normalizeResponse } from 'api/control/useControlProxy';
import { useQueryIntegrationNames } from 'api';

export default function useGetEventTraces(options = {}) {
  const { integrations, loading: integrationsLoading, error: integrationsError } = useQueryIntegrationNames();

  const [call, response] = useControlProxy({
    permission: permissions.readEvents,
    ...options,
  });

  const getEventTraces = ({ clusterId, ...queryArgs }) => {
    return call({
      path: PATH.EventTraces,
      method: METHOD.GET,
      body: { ...queryArgs },
      clusterId,
    });
  };

  const normalizedResponse = normalizeResponse(response);

  const transformedResponse = {
    events: transformResponse(normalizedResponse, integrations),
    loading: normalizedResponse.loading || integrationsLoading,
    error: normalizedResponse.error?.errorMsg || integrationsError?.message,
  };

  return [getEventTraces, transformedResponse];
}

function transformResponse(response, integrations) {
  if (!response?.data || !integrations) {
    return [];
  }

  const transformedResponse = response.data.traces.map(event => {
    const integration = integrations.find(integration => integration.id === event.integrationId);

    return {
      ...event,
      name: integration?.name || event.integrationName,
      starterkitId: event.integrationName,
    };
  });

  return transformedResponse;
}
